"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fiat = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _useContextSelector = require("use-context-selector");
var _ConfirmModal = require("./ConfirmModal");
var _providers = require("../providers");
var _page = require("../page");
var _hooks = require("../../../../../hooks");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Fiat = function Fiat(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  var ticker = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.ticker;
  });
  var to = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.to;
  });
  var amount = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.amount;
  });
  var _useContext = (0, _react.useContext)(_providers.CreateWithdrawContext),
    useCreateWithdraw = _useContext.useCreateWithdraw;
  var _useCreateWithdraw = useCreateWithdraw(),
    createWithdraw = _useCreateWithdraw.createWithdraw;
  var sendInfo = (0, _hooks.useCalculatedSendInfo)();
  return /*#__PURE__*/_react.default.createElement(_ConfirmModal.ConfirmModal, _extends({
    alertText: t('sendFiatAttention'),
    onSubmit: function onSubmit(_ref) {
      var withdrawKey = _ref.withdrawKey;
      return createWithdraw({
        withdrawKey: withdrawKey,
        amount: amount,
        fee: sendInfo.fee,
        to: to,
        ticker: ticker
      });
    }
  }, sendInfo, props));
};
exports.Fiat = Fiat;